module.exports = __webpack_public_path__ + "home/en-US/js/home-tabs/images/abcmouse-tab-active-mb-2f5599a969db03984d87b0e1c407f287.png";


//////////////////
// WEBPACK FOOTER
// ./home/en-US/js/home-tabs/images/abcmouse-tab-active-mb.png
// module id = kGN9
// module chunks = 0